import api from 'api';

export const loadUsers = api('GET /api/business-partners/fields/users');

export const loadActiveUsers = api(
  'GET /api/business-partners/fields/users/active'
);

export const loadPartnerCompany = api(
  'GET /api/business-partners/fields/partner-company/:id'
);

export const loadPartnerCompanies = api(
  'GET /api/business-partners/fields/partner-companies'
);

export const loadActivePartnerCompanies = api(
  'GET /api/business-partners/fields/partner-companies/active'
);

export const loadCustomerCompany = api(
  'GET /api/business-partners/fields/customer-company'
);

export const loadInvoiceLevels = api(
  'GET /api/business-partners/fields/invoice-levels'
);

export const loadIOTypes = api('GET /api/business-partners/fields/io-types');

export const loadCurrency = api('GET /api/business-partners/fields/currency');

export const loadExpenseTypes = api(
  'GET /api/business-partners/fields/expense-types'
);

export const loadNetworks = api('GET /api/business-partners/fields/networks');

export const loadPaymentTerms = api(
  'GET /api/business-partners/fields/payment-terms'
);

export const loadCountry = api('GET /api/business-partners/fields/country');

export const loadTimeZone = api('GET /api/business-partners/fields/time-zone');
